module.exports = __webpack_public_path__ + "assets/woman.png?v=b47a3ba887cb4986ac01453b86ba8dad";